<template>
  <div>

    <div class="row text-center">
      <!--<span>پایان بازه</span><i class="icon-bd-building"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-edit"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-accept"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-book-plus"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-check"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-close"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-delete"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-document"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-document-box-multiple"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-pencil"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-domain"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-star-circle"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bd-user"></i>-->

      <!--<span>پایان بازه</span><i class="icon-calendar-blank-outline"></i>-->
      <!--<span>پایان بازه</span><i class="icon-clock"></i>-->
      <!--<span>پایان بازه</span><i class="icon-account-card-details"></i>-->
      <!--<span>پایان بازه</span><i class="icon-account-edit"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bank"></i>-->
      <!--<span>پایان بازه</span><i class="icon-account-multiple"></i>-->
      <!--<span>پایان بازه</span><i class="icon-baseline-https-24px"></i>-->
      <!--<span>پایان بازه</span><i class="icon-book-plus"></i>-->
      <!--<span>پایان بازه</span><i class="icon-bulletin-board"></i>-->
      <!--<span>پایان بازه</span><i class="icon-calendar-edit"></i>-->
      <!--<span>پایان بازه</span><i class="icon-cart"></i>-->
      <!--<span>پایان بازه</span><i class="icon-cart-plus"></i>-->
      <!--<span>پایان بازه</span><i class="icon-check-circle-outline"></i>-->
      <!--<span>پایان بازه</span><i class="icon-close-circle-outline"></i>-->
      <!--<span>پایان بازه</span><i class="icon-content-duplicate"></i>-->
      <!--<span>پایان بازه</span><i class="icon-delete-empty"></i>-->
      <!--<span>پایان بازه</span><i class="icon-domain"></i>-->
      <!--<span>پایان بازه</span><i class="icon-drop"></i>-->
      <!--<span>پایان بازه</span><i class="icon-file-document"></i>-->
      <!--<span>پایان بازه</span><i class="icon-file-document-box-multiple"></i>-->
      <!--<span>پایان بازه</span><i class="icon-paperclip"></i>-->
      <!--<span>پایان بازه</span><i class="icon-ruler"></i>-->


      <div class="col-4">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>انتخاب کارگاه</span>
            </div>
          </div>
          <vs-select
            ref="selectedCompany"
            :isHeader="true"
            :data="companyList"
            :selectedVal="companyList.id"
            :header="{label:'companyName'}"
            :mode="'edit'"
            @dataChanged="companySelect"
          ></vs-select>

        </div>
      </div>

      <div class="input-group col-4 " v-if="showDate">
        <div class="input-group-prepend custom">
          <div class="input-group-text">
            <i class="icon-calendar-blank-outline"></i>
            <span>ابتدای بازه</span>
          </div>
        </div>
        <date-picker
          v-show=true
          :auto-submit="true"
          format="jYYYY-jMM-jDD"
          @input="setDateFromDatePicker"
          ref="datePicker1"
        >
          <slot>
            <input
              :readonly=true
              v-model="startDateJ"
              class="form-control date-input"
              @click="toggleStartDatePicker"
            >
          </slot>
        </date-picker>
      </div>
      <div class="input-group col-4" v-if="showDate1">
        <div class="input-group-prepend custom">
          <div class="input-group-text">
            <i class="icon-calendar-blank-outline"></i>
            <span>پایان بازه</span>
          </div>
        </div>
        <date-picker
          v-show=true
          :min="startDateJ"
          :auto-submit="true"
          format="jYYYY-jMM-jDD"
          @input="setDateFromDatePicker"
          ref="datePicker2"
        >
          <slot>
            <input
              :readonly=true
              v-model="endDateJ"
              class="form-control date-input"
              @click="toggleEndDatePicker"
            >
          </slot>
        </date-picker>
      </div>
    </div>


    <div class="col-12 text-center" v-if="showDate2">

      <date-picker
        v-show=true
        :highlight="highlightOrder"
        format="jYYYY-jMM-jDD"
        ref="datePicker3"
      >
        <slot>
          <button @click="showOrderTimesheet" class="btn iconed btn-info m-3"><i
            class="icon-calendar-blank-outline"></i><span>مشاهده تقویم</span></button>
        </slot>
      </date-picker>
    </div>

    <div class="row" v-if="showDate2">
      <div class="col-lg-12 col-sm-12 my-2">
        <div class="card shadow text-white  mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="bar-chart" width="1200" height="555"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr/>
    <div v-if="!showDate2" class="text-center">
      <h5>داده ای وجود ندارد</h5>
    </div>
    <div class="col-12" v-if="showDate2">
      <table class="table table-striped">
        <thead>
        <!--<tr>-->
        <!--<th scope="col" class="text-center">تاریخ</th>-->
        <!--</tr>-->
        </thead>
        <tbody>
        <tr v-for="(i, index) in planning">

          <th scope="row" class="text-center">{{i.date}}</th>
          <!--**********************-->
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col" class="text-center">کد برنامه</th>
              <th scope="col" class="text-center">نام محصول</th>
              <th scope="col" class="text-center">نام الگو</th>
              <th scope="col" class="text-center">نام شیفت</th>
              <th scope="col" class="text-center">ساعت</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in planning[index].ordersPlans">
              <td class="text-center">{{item.programCode}}</td>
              <td class="text-center">{{item.productName}}</td>
              <td class="text-center">{{item.patterrnName}}</td>
              <td class="text-center">{{item.shiftName}}</td>
              <td class="text-center">{{item.times}}</td>

            </tr>
            </tbody>
          </table>
          <!--***********************-->
        </tr>
        </tbody>
      </table>

    </div>


  </div>

</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import ShowProblemsModal from "../../components/ShowProblemsModal";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState} from "vuex";
  import ProblemDetails from "../../components/ProblemDetails.vue";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Utils from "../../_framework/utils/Utils";
  import Moment from "moment-jalali";
  import chart from "chart.js";
  import VsSelect from "../../_framework/VsSelect";


  export default {
    name: "totalcompanyplanning",
    components: {
      VsTable,
      datePicker: DatePicker,
      Moment,
      VsSelect,
    },
    data() {
      return {
        access: {},

        startDate: null,
        startDateJ: null,
        endDate: null,
        endDateJ: null,
        planning: [],
        planningTime: [],
        companyList: [],
        companyId: 0,
        showDate: false,
        showDate1: false,
        showDate2: false,
        backgroundColor: [],
        borderColor: [],
        shifts: [],
        companyShifts: [],
        shiftsData: [],
        dates: [],
        todayDate: null,

      };
    },
    beforeMount() {
      this.backgroundColor = [];
      this.borderColor = [];
      this.backgroundColor.push('rgba(255,193,7,0.71)');
      this.borderColor.push('rgba(255,143,0,0.71)');


      this.backgroundColor.push('rgba(249,60,103,0.71)');
      this.borderColor.push('rgba(198,40,40,0.71)');

      this.backgroundColor.push('rgba(3,169,244,0.71)');
      this.borderColor.push('rgba(3,169,244,0.71)');

      this.backgroundColor.push('rgba(76,175,80,0.71)');
      this.borderColor.push('rgba(76,175,80,0.7)');

      this.backgroundColor.push('rgba(205,220,57,0.71)');
      this.borderColor.push('rgba(135,150,40,0.71)');

      this.todayDate = new Date();
      this.todayDate = new Date().toJSON().slice(0, 10);
      this.tempDate = Moment(this.todayDate, "YYYY-MM-DD");
      this.todayDate = this.tempDate.format("jYYYY-jMM-jDD");
      new BaseService('Company', '/GetAll').getList().then((response) => {
        this.companyList = response.data;
      }).catch((error) => {
        console.log(error)
      });
    },
    mounted() {

    },
    methods: {


      toggleStartDatePicker() {
        this.dateClicked = 1;
        this.$refs.datePicker1.togglePicker();
      },
      toggleEndDatePicker() {
        this.dateClicked = 2;
        this.$refs.datePicker2.togglePicker();
      },
      setDateFromDatePicker(date) {
        if (this.dateClicked === 1) {
          this.startDateJ = date;
          this.showDate1 = true;
        } else if (this.dateClicked === 2) {
          this.endDateJ = date;
          this.getCompanyPlans();
        }
      },
      getCompanyPlans() {
        let date = Moment(this.startDateJ, "jYYYY/jMM/jDD");
        this.startDate = date.format("YYYY-MM-DD");

        let date2 = Moment(this.endDateJ, "jYYYY/jMM/jDD");
        this.endDate = date2.format("YYYY-MM-DD");
        let createTimesheet = {
          startDate: (this.startDate),
          endDate: (this.endDate),
          companyId: this.companyId
        };
        this.planning = [];
        this.planningTime = [];
        this.shifts = [];
        this.dates = [];
        this.companyShifts = [];
        this.shiftsData = [];
        new BaseService('Planning', '/GetCompanyPlanning').create(createTimesheet).then((response) => {
          this.planning = response.data;
          if (this.planning.length > 0) {
            this.showDate2 = true;
            for (let i = 0; i < this.planning.length; i++) {
              this.planning[i].date = Moment(this.planning[i].date.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
            }
          }
        }).catch((error) => {
          Utils.handleErrorWithNotification("" + error, this.$noty);
          console.log(error);
        });

        new BaseService('Planning', '/GetCompanyTiming').create(createTimesheet).then((response) => {
            this.planningTime = response.data;
            if (this.planningTime != null && this.showDate2) {
              for (let item of this.planningTime.totalDateShifts) {
                item.date = Moment(item.date.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
              }

              for (let item of this.planningTime.totalShifts) {
                this.shifts.push(item.name);
              }
              for (let item of this.planningTime.totalDateShifts) {
                this.dates.push(item.date);
              }

              let shIndex = 0;
              for (let mainShift of this.shifts) {

                for (let comp of this.planningTime.totalDateShifts) {
                  let countt = 0;
                  for (let shift of comp.totalShifts) {
                    if (shift.name === mainShift) {
                      countt = shift.used;
                      break;
                    }
                  }
                  this.companyShifts.push(countt);
                }

                console.log(mainShift);
                console.log(this.companyShifts);

                const data = {
                  label: mainShift,
                  data: this.companyShifts,
                  backgroundColor: this.backgroundColor[shIndex],
                  borderColor: this.borderColor[shIndex],

                };
                this.shiftsData.push(data);
                this.companyShifts = [];
                shIndex = shIndex + 1;
                if (shIndex > 4) {
                  shIndex = 0;
                }

              }


              var ctx = document.getElementById('bar-chart').getContext('2d');
              var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                  labels: this.dates,
                  datasets: this.shiftsData,
                }, options: {
                  scales: {
                    xAxes: [{
                      stacked: true
                    }],
                    yAxes: [{
                      stacked: true
                    }]
                  },
                  title: {
                    display: true,
                    text: 'ظرفیت ساعتهای کارگاه'
                  },
                }

              });
            }

          }
        ).catch((error) => {
          console.log(error)
        })

      },
      companySelect(prop, data) {
        this.companyId = data.id;
        this.showDate = true;
        this.showDate1 = false;
        this.showDate2 = false;
        this.startDate = this.todayDate;
        this.endDate = this.todayDate;

      },
      highlightOrder(formatted, dateMoment, checkingFor) {
        let attributes = {'title': ''};
        for (let i = 0; i < this.planning.length; i++) {
          if (checkingFor === 'day' && formatted === this.planning[i].date) {
            // console.log("28")
            attributes['style'] = 'background-color: #a7a040 !important; ';
            let str = "";
            for (let j = 0; j < this.planning[i].ordersPlans.length; j++) {
              str = str + ' | ' +
                this.planning[i].ordersPlans[j].productName + ' با الگوی ' +
                this.planning[i].ordersPlans[j].patterrnName + ' کد برنامه ' +
                this.planning[i].ordersPlans[j].programCode + ' در شیفت ' +
                this.planning[i].ordersPlans[j].shiftName + ' از ساعت ' +
                this.planning[i].ordersPlans[j].times;
            }
            attributes['title'] = str;
          }
        }
        return attributes;
      },
      showOrderTimesheet() {
        this.$refs.datePicker3.togglePicker();
      },


    }
    ,
    created: () => {
    },

    computed:
      {
        ...
          mapState(["selectedRows", "currentService", "vsTableFeed"]),

      }
  }
  ;
</script>



